import { FormikProvider } from 'formik';
import LifecareStudioInfoSection from './LifecareStudioInfoSection';
import LifecareStudioTextSection from './LifecareStudioTextSection';
import LifecareStudioFutureCareNeedsSection from './LifecareStudioFutureCareNeedsSection';
import LifecareStudioSummarySection from './LifecareStudioSummarySection';
import LifecareStudioNewPlanBanner from './LifecareStudioNewPlanBanner';
import { planFieldPaths } from '../../utils/lifecarePlanUtils';
import { LIFECARE_TAB_TYPES } from "@demandproai/shared";

// Maps the active lifecare tab to the form block(s) we render for it. Keeping the
// switch here (rather than baking it into each section component) keeps the section
// components dumb -- they just render their slice.
const renderActiveSection = ({ values, activeTab, handlers }) => {
  switch (activeTab?.tabType) {
    case LIFECARE_TAB_TYPES.INFO:
      return <LifecareStudioInfoSection />;
    case LIFECARE_TAB_TYPES.DIAGNOSIS:
      return (
        <LifecareStudioTextSection
          titleFieldName={planFieldPaths.diagnosis('title')}
          contentFieldName={planFieldPaths.diagnosis('content')}
        />
      );
    case LIFECARE_TAB_TYPES.LIFE_EXPECTANCY:
      return (
        <LifecareStudioTextSection
          titleFieldName={planFieldPaths.lifeExpectancy('title')}
          contentFieldName={planFieldPaths.lifeExpectancy('content')}
          numericFieldName={planFieldPaths.lifeExpectancy('lifeExpectancy')}
          numericLabel="Life Expectancy (years remaining)"
          contentRows={3}
        />
      );
    case LIFECARE_TAB_TYPES.SUMMARY_OF_RECORDS:
      return (
        <LifecareStudioTextSection
          titleFieldName={planFieldPaths.summaryOfRecords('title')}
          contentFieldName={planFieldPaths.summaryOfRecords('content')}
        />
      );
    case LIFECARE_TAB_TYPES.FUTURE_CARE_NEEDS:
      return (
        <LifecareStudioFutureCareNeedsSection
          subsections={values?.futureCareNeeds?.subsections}
          subsectionSubtotals={handlers.subsectionSubtotals}
          onAddSubsection={handlers.handleAddSubsection}
          onRemoveSubsection={handlers.handleRemoveSubsection}
          onAddRow={handlers.handleAddRow}
          onRemoveRow={handlers.handleRemoveRow}
          onMoveRow={handlers.handleMoveRow}
          onRowFieldChange={handlers.handleRowFieldChange}
        />
      );
    case LIFECARE_TAB_TYPES.SUMMARY:
      return <LifecareStudioSummarySection summaryLines={handlers.summaryLines} />;
    default:
      return null;
  }
};

const LifecareStudioForm = ({ formState, isNewPlan, activeTab }) => {
  const {
    formik,
    values,
    subsectionSubtotals,
    summaryLines,
    handleAddSubsection,
    handleRemoveSubsection,
    handleAddRow,
    handleRemoveRow,
    handleMoveRow,
    handleRowFieldChange,
  } = formState;

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit} noValidate>
        {isNewPlan && <LifecareStudioNewPlanBanner />}
        {renderActiveSection({
          values,
          activeTab,
          handlers: {
            subsectionSubtotals,
            summaryLines,
            handleAddSubsection,
            handleRemoveSubsection,
            handleAddRow,
            handleRemoveRow,
            handleMoveRow,
            handleRowFieldChange,
          },
        })}
      </form>
    </FormikProvider>
  );
};

export default LifecareStudioForm;
